/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_SettingsInputs */

const en_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account Settings`)
};

const nl_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accountinstellingen`)
};

/**
* | output |
* | --- |
* | "Account Settings" |
*
* @param {Account_SettingsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const account_settings = /** @type {((inputs?: Account_SettingsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_SettingsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_account_settings(inputs)
	return en_account_settings(inputs)
});